import React from "react";
import UseOurLiveChat from "~/common/UseOurLiveChat/UseOurLiveChat";
import useIsMounted from "~/common/useIsMounted";
export interface SearchTip {
  heading: string;
  subText: string;
  id: number;
}
interface Props {
  searchTips?: SearchTip[];
}
export default function SearchTips({
  searchTips
}: Props) {
  const mounted = useIsMounted();
  const defaultSearchTips = [{
    heading: "Not sure which keywords to use?",
    subText: 'Try using specific words instead of more general ones. For example, searching for "strawberry jam" will return fewer results than "jam", but the results will be more focused on a specific kind of product.',
    id: 0
  }, {
    heading: "Expand your search by adding or removing the letter ‘s’",
    subText: 'If searching for "spoons" doesn\'t return everything you are looking for, try "spoon".',
    id: 1
  }];
  return <div className="search-help help__no-results" data-sentry-component="SearchTips" data-sentry-source-file="SearchTips.tsx">
      <div id="search_again">
        <p id="search_tips" />
        <h2>Search tips</h2>
        {(searchTips || defaultSearchTips).map(({
        heading,
        subText,
        id
      }) => <p className="small" key={id}>
            <span className="font-bold block">{heading}</span>
            {subText}
          </p>)}
        <p className="small">
          <span className="font-bold block">Try browsing our products</span>
          Use the category links on the bottom of the page to find the products
          that fit your needs.
        </p>
      </div>
      <UseOurLiveChat mounted={mounted} className="m-3 border-none" data-sentry-element="UseOurLiveChat" data-sentry-source-file="SearchTips.tsx" />
    </div>;
}